export default __webpack_public_path__ + "static/media/painting20.364cc8db.jpg";